import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'urgency';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold tracking-wide transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed border-2';
  const variants = {
    primary: 'bg-primary border-primary text-black hover:bg-transparent hover:text-primary hover:shadow-[0_0_20px_rgba(0,229,255,0.3)]',
    secondary: 'bg-transparent border-white/20 text-white hover:border-white hover:bg-white/5',
    urgency: 'bg-urgency border-urgency text-black hover:bg-transparent hover:text-urgency hover:shadow-[0_0_20px_rgba(255,183,0,0.3)]'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]} 
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} {...props} data-id="element-151">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-152" />}
    </motion.button>;
}